import { INTEGRATIONS_ACTIONS } from '@/constant/eventActions'
import store from '@/vuex/store'

const ahaGPTUrl = store.getters['ahaGpt/ahaGPTUrl']

const iconPowerPoint = require('@/assets/images/integrations-center/PowerPoint.png')
const iconTeams = require('@/assets/images/integrations-center/Teams.png')
const iconZoom = require('@/assets/images/integrations-center/Zoom.png')
const iconGoogleSlides = require('@/assets/images/integrations-center/google-slides/GoogleSlides.png')
const iconAhaSlidesGPT = require('@/assets/images/integrations-center/aha-slides-gpt/chatGPT.png')

const msTeam = require('@/assets/images/integrations-center/list_msteams.webp')
const pptImg = require('@/assets/images/integrations-center/list_ppt.webp')
const zoomImg = require('@/assets/images/integrations-center/list_zoom.webp')
const googleSlidesImg = require('@/assets/images/integrations-center/list_google_slides.png')
const ahaSlidesGPTImg = require('@/assets/images/integrations-center/list_aha_gpt.png')

const pptDescription = 'Seamlessly add interactive polls, quizzes, and Q&A sessions to your PowerPoint slides, making every presentation an engaging and memorable experience.'
const msTeamsDescription = 'Effortlessly incorporate live polls, quizzes, and interactive Q&A sessions into your Microsoft Teams meetings, fostering real-time participation and feedback.'
const zoomDescription = 'Elevate your Zoom meetings with AhaSlides Zoom Integration, seamlessly transforming virtual gatherings into dynamic, interactive experiences with live polls, quizzes, and Q&A sessions, engaging your audience like never before.'
const googleSlidesDescription = 'AhaSlides empowers presenters to transform Google Slides™ into engaging, interactive presentations with word clouds, dynamic quizzes, live polls, Q&A and more.'
const ahaSlidesGPTDescription = 'Effortlessly share your prompts with AhaSlides GPT in ChatGPT and watch as it directly creates and customizes interactive presentations on AhaSlides!'

const pptImg1 = require('@/assets/images/integrations-center/ppt/ppt-1.webp')
const pptImg2 = require('@/assets/images/integrations-center/ppt/ppt-2.webp')
const pptImg3 = require('@/assets/images/integrations-center/ppt/ppt-3.webp')
const pptImg4 = require('@/assets/images/integrations-center/ppt/ppt-4.webp')

const mstImg1 = require('@/assets/images/integrations-center/msteams/ms-1.webp')
const mstImg2 = require('@/assets/images/integrations-center/msteams/ms-2.webp')
const mstImg3 = require('@/assets/images/integrations-center/msteams/ms-3.webp')
const mstImg4 = require('@/assets/images/integrations-center/msteams/ms-4.webp')

const zoomImg1 = require('@/assets/images/integrations-center/zoom/zoom-01.webp')
const zoomImg2 = require('@/assets/images/integrations-center/zoom/zoom-02.webp')
const zoomImg3 = require('@/assets/images/integrations-center/zoom/zoom-03.webp')
const zoomImg4 = require('@/assets/images/integrations-center/zoom/zoom-04.webp')

const googleSlidesImg1 = require('@/assets/images/integrations-center/google-slides/google-slides-1.webp')
const googleSlidesImg2 = require('@/assets/images/integrations-center/google-slides/google-slides-2.webp')
const googleSlidesImg3 = require('@/assets/images/integrations-center/google-slides/google-slides-3.webp')
const googleSlidesImg4 = require('@/assets/images/integrations-center/google-slides/google-slides-4.webp')

const ahaSlidesGPTImg1 = require('@/assets/images/integrations-center/aha-slides-gpt/aha-slides-gpt-1.webp')
const ahaSlidesGPTImg2 = require('@/assets/images/integrations-center/aha-slides-gpt/aha-slides-gpt-2.webp')
const ahaSlidesGPTImg3 = require('@/assets/images/integrations-center/aha-slides-gpt/aha-slides-gpt-3.webp')
const ahaSlidesGPTImg4 = require('@/assets/images/integrations-center/aha-slides-gpt/aha-slides-gpt-4.webp')

const helpCenterText = '(Help Center guide - 5 mins read)'
const helpCenterVideoDesc = '(AhaSlides YouTube - 1 min video)'
const helpCenter5minVideoDesc = '(AhaSlides YouTube - 5 min video)'

const guideLine = {
  addAhaSlides: 'Add AhaSlides to a meeting',
  logIn: 'Log in to AhaSlides',
  selectPresentation: 'Select your presentation',
  present: 'Present your AhaSlides presentation',
}
const guideLineChatGPT = {
  openGPT: 'Open AhaSlides GPT',
  setUp: 'Set things up',
  createSlides: 'Create slides while you chat, in a smart way',
  fineTune: 'Fine-tune your presentation on the fly',
}

export const groupItems = [
  {
    name: 'Presentations',
    items: [
      {
        name: 'PowerPoint',
        id: 'powerpoint',
        desc: pptDescription,
        icon: 'PowerPoint',
        viewbox: '0 0 28 28',
        iconUrl: iconPowerPoint,
        cardAction: INTEGRATIONS_ACTIONS.CARD_CLICK,
        btnAction: INTEGRATIONS_ACTIONS.GET_BTN_CLICK,
        isAddBtn: false,
        imageSrc: pptImg,
        url: 'https://appsource.microsoft.com/en-us/product/office/WA200004824?tab=Overview',
      },
      {
        name: 'Google Slides',
        id: 'googleSlides',
        desc: googleSlidesDescription,
        icon: 'google-slides-icon',
        viewbox: '0 0 48 48',
        iconUrl: iconGoogleSlides,
        cardAction: INTEGRATIONS_ACTIONS.CARD_CLICK,
        btnAction: INTEGRATIONS_ACTIONS.GET_BTN_CLICK,
        isAddBtn: false,
        imageSrc: googleSlidesImg,
        url: 'https://workspace.google.com/marketplace/app/ahaslides_for_google_slides_word_cloud_q/362095682738',
      },
    ],
  },
  {
    name: 'Video conferencing',
    items: [
      {
        name: 'Microsoft Teams',
        desc: msTeamsDescription,
        icon: 'ms-teams',
        id: 'msteam',
        viewbox: '0 0 20 21',
        iconUrl: iconTeams,
        cardAction: INTEGRATIONS_ACTIONS.CARD_CLICK,
        btnAction: INTEGRATIONS_ACTIONS.ADD_BTN_CLICK,
        isAddBtn: true,
        imageSrc: msTeam,
        url: 'https://teams.microsoft.com/l/app/1e3650a1-32d1-442d-9adb-70f205832f06?source=app-details-dialog',
      },
      {
        name: 'Zoom',
        id: 'zoom',
        desc: zoomDescription,
        icon: 'zoom',
        viewbox: '0 0 28 28',
        iconUrl: iconZoom,
        cardAction: INTEGRATIONS_ACTIONS.CARD_CLICK,
        btnAction: INTEGRATIONS_ACTIONS.ADD_BTN_CLICK,
        isAddBtn: true,
        imageSrc: zoomImg,
        url: 'https://marketplace.zoom.us/apps/dkSZ5rgQTrmPRKS0GJcjNg',
      },
    ],
  },
  {
    name: 'Generative AI tools',
    items: [
      {
        name: 'ChatGPT',
        id: 'chatGPT',
        desc: ahaSlidesGPTDescription,
        icon: 'chatGPT',
        viewbox: '0 0 17 16',
        iconUrl: iconAhaSlidesGPT,
        cardAction: INTEGRATIONS_ACTIONS.CARD_CLICK,
        btnAction: INTEGRATIONS_ACTIONS.ADD_BTN_CLICK,
        isAddBtn: false,
        isUseBtn: true,
        imageSrc: ahaSlidesGPTImg,
        url: ahaGPTUrl,
      },
    ],
  },
]

export const menuItems = [
  {
    name: 'PowerPoint',
    icon: 'PowerPoint',
    viewbox: '0 0 28 28',
    id: 'powerpoint',
    title: 'AhaSlides for Powerpoint',
    iconUrl: iconPowerPoint,
    menuAction: INTEGRATIONS_ACTIONS.MENU_POWER_POINT,
    btnAction: INTEGRATIONS_ACTIONS.GET_BTN_CLICK,
    isAddBtn: false,
    guides: [
      {
        imgSrc: pptImg1,
        title: 'Open the AhaSlides add-in in PowerPoint',
        desc: [
          'On your PowerPoint presentation, click Insert in the top toolbar, then the button labelled Get Add-Ins',
          'guide_ppt_search_bar',
        ],
      },
      {
        imgSrc: pptImg2,
        title: 'Sign in to AhaSlides from Powerpoint',
        desc: [
          'Log in to your AhaSlides account the same way you would on AhaSlides.',
        ],
      },
      {
        imgSrc: pptImg3,
        title: 'Add your Slide',
        desc: [
          'Select the specific slide you want to add. Alternatively, you can click the "Edit" button located at the bottom right corner to make any desired changes using the editor interface',
          'guide_ppt_add_slide',
        ],
      },
      {
        imgSrc: pptImg4,
        title: 'Present your Slides in PowerPoint',
        desc: ['Once your PowerPoint presentation is in slide show mode, you can navigate to AhaSlides slides and present them in the same way as you would on AhaSlides. The audience can interact with your slides on their devices.'],
      },
    ],
    url: 'https://appsource.microsoft.com/en-us/product/office/WA200004824?tab=Overview',
    desc: pptDescription,
    howitworks: [
      'Create your interactive slides directly in PowerPoint',
      'Participants can join by scanning the QR code on the slide or via a link',
      'Don’t forget to add the Leaderboard slide to maximise the fun',
    ],
    news: [
      'Available with all slide types and features available on your plan',
      'Edit directly in PowerPoint',
      'Log-in only once',
    ],
    tips: [
      // {
      //   text: '1-minute explainer',
      //   desc: '(AhaSlides YouTube - 44 seconds video)',
      //   link: '',
      // },
      {
        text: 'power_point_link_tips_1',
        desc: helpCenterText,
        link: 'https://help.ahaslides.com/portal/en/kb/articles/using-powerpoint-s-ahaslides-add-in',
      },
      {
        text: '[1 min Tutorial] AhaSlides Add-in for PowerPoint - new version',
        desc: helpCenterVideoDesc,
        link: 'https://youtu.be/skSRwpW7Lb0',
      },
    ],
  },
  {
    name: 'Google Slides',
    icon: 'google-slides-icon',
    viewbox: '0 0 48 48',
    id: 'googleSlides',
    iconWidth: 42,
    title: 'AhaSlides for Google Slides',
    desc: googleSlidesDescription,
    iconUrl: iconGoogleSlides,
    menuAction: INTEGRATIONS_ACTIONS.MENU_GOOGLE_SLIDES,
    btnAction: INTEGRATIONS_ACTIONS.GET_BTN_CLICK,
    isAddBtn: false,
    guides: [
      {
        imgSrc: googleSlidesImg1,
        title: 'Open the AhaSlides add-on in Google Slides',
        desc: [
          "On your Google Slides presentation, click on 'Extensions' in the top toolbar, then select 'Add-ons' > 'Get add-ons'.",
          "In the search bar, type 'AhaSlides for Google Slides™: Word Clouds and Quizzes', then click 'Install'.",
          "Once installed, go back to 'Extensions' and select 'AhaSlides for Google Slides™: Word Clouds and Quizzes' > 'Open Sidebar' to open the AhaSlides Add-on sidebar.",
        ],
      },
      {
        imgSrc: googleSlidesImg2,
        title: 'Sign in to AhaSlides from Google Slides',
        desc: [
          'After opening the sidebar, log in to your AhaSlides account as you normally would.',
        ],
      },
      {
        imgSrc: googleSlidesImg3,
        title: 'Adding interactive slides directly on your Google Slides',
        desc: [
          'From the sidebar, choose the type of interactive slide you’d like to add to your Google Slides presentation (e.g., Poll, Pick Answer, Word Cloud).',
          'Customize the slide content directly from the AhaSlides sidebar to suit your presentation.',
        ],
      },
      {
        imgSrc: googleSlidesImg4,
        title: 'Presenting your interactive slides',
        desc: [
          "Once you’ve added and customized your interactive slides, navigate back to the home screen of the sidebar and click 'Present with AhaSlides'.",
          "You can then choose 'Present now' to present from the current slide or 'Present from beginning'. This will open a new tab, switching your AhaSlides slides to presenting mode.",
          'During your presentation, responses from your audience will appear in real time on your AhaSlides slides.',
        ],
      },
    ],
    url: 'https://workspace.google.com/marketplace/app/ahaslides_for_google_slides_word_cloud_q/362095682738',
    howitworks: [
      'Create your interactive slides directly in Google Slides',
      'Present with AhaSlides',
      'Participants can join by scanning the QR code on the slide or via a link',
    ],
    tips: [
      {
        text: 'Using the AhaSlides App on Google Slides',
        desc: helpCenterText,
        link: 'https://help.ahaslides.com/portal/en/kb/articles/using-the-ahaslides-add-on-in-google-slides',
      },
      {
        text: 'Supercharge Your Google Slides with AhaSlides 🎯✨ | AhaSlides x Google Slides',
        desc: helpCenterVideoDesc,
        link: 'https://www.youtube.com/watch?v=ZP46DfJ9hZQ',
      },
    ],
  },
  {
    name: 'Microsoft Teams',
    icon: 'ms-teams',
    viewbox: '0 0 20 21',
    id: 'msteam',
    title: 'AhaSlides for Microsoft Teams',
    desc: msTeamsDescription,
    iconUrl: iconTeams,
    menuAction: INTEGRATIONS_ACTIONS.MENU_TEAMS,
    btnAction: INTEGRATIONS_ACTIONS.ADD_BTN_CLICK,
    isAddBtn: true,
    guides: [
      {
        imgSrc: mstImg1,
        title: guideLine.addAhaSlides,
        desc: [
          'In the pop-up window, click the purple dropdown menu and select Add to a meeting',
          'In the search bar, type in the name of your meeting and select it from the dropdown list. Then, click the button labelled Set up a tab',
        ],
      },
      {
        imgSrc: mstImg2,
        title: guideLine.logIn,
        desc: ['In the next pop-up window, sign into your AhaSlides account.'],
      },
      {
        imgSrc: mstImg3,
        title: guideLine.selectPresentation,
        desc: ['Select the presentation you would like to host in your meeting, then click the Save button'],
      },
      {
        imgSrc: mstImg4,
        title: guideLine.present,
        desc: [
          'To present on Microsoft Teams, simply click Join to start the call. You can share your screen to show the presentation, the audience can interact straight in Teams without needing another device.',
        ],
      },
    ],
    url: 'https://teams.microsoft.com/l/app/1e3650a1-32d1-442d-9adb-70f205832f06?source=app-details-dialog',
    howitworks: [
      'Available with all slide types and features available on your plan',
      'Add AhaSlides to your existing meeting via the + button',
      'Set up your polls and Q&A in advance',
      'Participants can interact directly from the meeting window without switching screens or devices',
    ],
    tips: [
      {
        text: '[1 min Tutorial] AhaSlides Add-in for Microsoft Teams | AhaSlides x Teams',
        desc: helpCenterVideoDesc,
        link: 'https://www.youtube.com/watch?v=JU_woymFR8A',
      },
      {
        text: 'Using the AhaSlides App on Microsoft Teams',
        desc: helpCenterText,
        link: 'https://help.ahaslides.com/portal/en/kb/articles/using-the-ahaslides-app-on-microsoft-teams',
      },
    ],
  },
  {
    name: 'Zoom',
    icon: 'zoom',
    viewbox: '0 0 28 28',
    id: 'zoom',
    title: 'AhaSlides for Zoom',
    desc: zoomDescription,
    iconUrl: iconZoom,
    menuAction: INTEGRATIONS_ACTIONS.MENU_ZOOM,
    btnAction: INTEGRATIONS_ACTIONS.ADD_BTN_CLICK,
    isAddBtn: true,
    guides: [
      {
        imgSrc: zoomImg1,
        title: guideLine.addAhsSlide,
        desc: [
          'Open the AhaSlides app in your Zoom Apps, then click Open AhaSlides in a Zoom meeting.',
          'Alternatively, start a new Zoom meeting and launch the AhaSlides app right on your meeting screen.',
        ],
      },
      {
        imgSrc: zoomImg2,
        title: guideLine.logIn,
        desc: [
          'Select Host a presentation and log into your AhaSlides account.',
        ],
      },
      {
        imgSrc: zoomImg3,
        title: guideLine.selectPresentation,
        desc: [
          'Choose a presentation from your list or inside a folder and allow screen sharing.',
          'In the next prompt, click Allow to send invitations to all the meeting participants.',
        ],
      },
      {
        imgSrc: zoomImg4,
        title: guideLine.present,
        desc: ['Run your AhaSlides presentation as usual, and your audience will respond live within the Zoom meeting. Their responses will be collected and displayed on your shared screen.'],
      },
    ],
    url: 'https://marketplace.zoom.us/apps/dkSZ5rgQTrmPRKS0GJcjNg',
    howitworks: [
      'Add AhaSlides through the “App” tab and open it during your Zoom meeting',
      'Automatically log in via your web browser, select your presentation, and start your slideshow!',
      'Participants can interact directly from the meeting window without switching screens or devices',
      'Supported on Zoom desktop, and applicable for all AhaSlides subscriptions and slide types',
    ],
    tips: [
      {
        text: 'Using the AhaSlides App on Zoom',
        desc: helpCenterText,
        link: 'https://help.ahaslides.com/portal/en/kb/articles/using-the-ahaslides-app-on-zoom',
      },
    ],
  },
  {
    name: 'ChatGPT',
    icon: 'chatGPT',
    viewbox: '0 0 17 16',
    id: 'chatGPT',
    title: 'AhaSlides GPT Plugin for ChatGPT',
    desc: ahaSlidesGPTDescription,
    iconUrl: iconAhaSlidesGPT,
    menuAction: INTEGRATIONS_ACTIONS.MENU_CHAT_GPT,
    btnAction: INTEGRATIONS_ACTIONS.ADD_BTN_CLICK,
    isAddBtn: false,
    isUseBtn: true,
    guides: [
      {
        imgSrc: ahaSlidesGPTImg1,
        title: guideLineChatGPT.openGPT,
        desc: [
          'In ChatGPT, click Explore GPTs on the left sidebar.',
          'Search for AhaSlides GPT, then click New Chat to begin.',
        ],
      },
      {
        imgSrc: ahaSlidesGPTImg2,
        title: guideLineChatGPT.setUp,
        desc: [
          'Enter your first prompt—this could be an outline, topic idea, or anything you want to present.',
          'When ChatGPT asks for access, sign in to AhaSlides and click Allow to let it create slides for you.',
        ],
      },
      {
        imgSrc: ahaSlidesGPTImg3,
        title: guideLineChatGPT.createSlides,
        desc: [
          'Split your screen so you can chat on one side and see the slides take shape on the other.',
          'Want more slides? Just keep chatting. AhaSlides GPT adds them as you go.',
        ],
      },
      {
        imgSrc: ahaSlidesGPTImg4,
        title: guideLineChatGPT.fineTune,
        desc: [
          'Ask ChatGPT to tweak titles, update content, or polish your layout.',
          'See updates pop up instantly on AhaSlides—no refresh needed.',
        ],
      },
    ],
    url: ahaGPTUrl,
    howitworks: [
      'Log in to ChatGPT and open the AhaSlides GPT plugin.',
      'Enter your prompt, authenticate if needed, and let AhaSlides GPT work its magic.',
      'View and refine the results directly in the AhaSlides interface.',
    ],
    tips: [
      {
        text: '[5 min Tutorial] AhaSlides GPT: Create Interactive Presentations Instantly with AI',
        desc: helpCenter5minVideoDesc,
        link: 'https://www.youtube.com/watch?v=YbemdQrtXPM',
      },
    ],
  },
]
